<template>
    <div class="import-statistics-material">
      <div class="table-toolber">
        <el-button
          :loading="loading.export"
          @click="exportFile"
        >导出</el-button>
  
        <el-button
          :loading="loading.refresh"
          @click="refreshFn"
        >刷新</el-button>
        <div class="taber-right">
            <span>报关金额（USD）：</span>
            <span class="amount">{{ $filters.formatMoney(sumData.totalUsdAmount) }}</span>
            &nbsp;&nbsp;&nbsp;&nbsp;
            已进口未付汇（USD）：
            <span class="amount">{{ $filters.formatMoney(sumData.unPayAmountUsd) }} </span>
        </div>
      </div>
  
      <div class="table--common">
        <el-table
          class="p-table"
          row-key="id"
          :data="tableData"
          v-loading="loading.table"
          :cell-class-name="cellClassName"
          show-summary
          :summary-method="summaryMethod"
          @selection-change="selectionChange"
          stripe
        >
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column type="index" label="序号" width="60" fixed="left"></el-table-column>
          <el-table-column
            v-for="(item, index) in columns"
            :key="index"
            :prop="item.props"
            :align="item.align"
            :label="item.labels"
            :sortable="item.sort"
            :min-width="item.widths"
            :show-overflow-tooltip="true"
          >
            <template #header>
              <template v-if="item.props === 'payRate'">
                 <div  class="statisticsPopover">
                {{ item.labels }} 

                <!-- <el-tooltip class="table-hd-question" content="付汇汇率要订单全部付汇后才显示，有多个汇率则用全部的折算人民币之和除以总价之和，保留4位小数, 页面标红显示" placement="top">
                    <el-icon class="table-hd-question"><QuestionFilled /></el-icon>
                </el-tooltip> -->
                <el-popover
                    placement="top"
                    popper-class='form-pop'
                    :width="400"
                    trigger="hover"
                    >
                    <template #reference>
                        <div>
                            <ab-svg name="my-issue" style="cursor: pointer;width: 16px;height: 16px"></ab-svg>
                        </div>
                    </template>
                    <template #default>
                        <p>付汇汇率要订单全部付汇后才显示，有多个汇率则用全部的折算人民币之和除以总价之和，保留4位小数, 页面标红显示</p> 
                    </template>
                </el-popover>
                </div>
              </template>
  
              <template v-else-if="item.props === 'priceCal'">
                 <div  class="statisticsPopover">
                {{ item.labels }} 
                <!-- <el-tooltip class="table-hd-question" content="单价仅为财务做账提供参考，不作为结算依据；以海关票作为进项，单价=（海关汇率X总价+进口税金+服务费+杂费）/数量；以13%增值税专用发票作为进项，单价=（付汇汇率X总价+进口税金+服务费+杂费）/数量，无付汇汇率时用海关汇率暂估，最终以增值税专票为准" placement="top">
                    <el-icon class="table-hd-question"><QuestionFilled /></el-icon>
                </el-tooltip> -->
                <el-popover
                    placement="top"
                    popper-class='form-pop'
                    :width="700"
                    trigger="hover"
                    >
                    <template #reference>
                        <div>
                            <ab-svg name="my-issue" style="cursor: pointer;width: 16px;height: 16px"></ab-svg>
                        </div>
                    </template>
                    <template #default>
                        <p>单价仅为财务做账提供参考，不作为结算依据；以海关票作为进项，单价=（海关汇率X总价+进口税金+服务费+杂费）/数量；以13%增值税专用发票作为进项，单价=（付汇汇率X总价+进口税金+服务费+杂费）/数量，无付汇汇率时用海关汇率暂估，最终以增值税专票为准</p> 
                    </template>
                </el-popover>
                </div>
              </template>
  
              <template v-else>{{ item.labels }}</template>
            </template>
  
            <template #default="scope">
              <template v-if="item.type == 'money'">
                {{ $filters.formatMoney(scope.row[item.props], item.isDecimal) }}
              </template>
  
              <template v-else>{{ scope.row[item.props] }}</template>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <div class="list-page">
            <ab-page
                :pageTotal="pages.total" 
                :currentPage='pages.currentPage' 
                :pageSize="pages.pageSize" 
                :pageSizes="pages.pageSizes"
                @searchForm="searchForm"
            ></ab-page>
        </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'import-statistics-material', // 进口统计-物料汇总
    props: {
      formSearch: {
        type: Object
      },
  
      sumData: {
        type: Object
      }
    },
    data () {
      return {
        loading: {
          export: false,
          refresh: false,
          table: false
        },
        // 表格数据
        columns: [
          {
            props: 'portDate',
            labels: '放行时间',
            widths: 160
          },
          {
            props: 'custOrderNo',
            labels: '订单编号',
            widths: 180
          },
          {
            props: 'supplierIdDesc',
            labels: '供应商',
            widths: 220
          },
          {
            props: 'declareGoodsName',
            labels: '货物名称',
            widths: 150
          },
          {
            props: 'model',
            labels: '规格型号',
            widths: 150
          },
          {
            props: 'brand',
            labels: '品牌',
            widths: 150
          },
          {
            props: 'count',
            labels: '数量',
            widths: 100
          },
          {
            props: 'baseUnitIdDesc',
            labels: '单位',
            widths: 100
          },
          {
            props: 'price',
            labels: '单价',
            widths: 140,
            type: 'money',
            isDecimal: true,
            align: 'right'
          },
          {
            props: 'amount',
            labels: '总价',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'currencyIdDesc',
            labels: '币别',
            widths: 80,
          },
          {
            props: 'customsRate',
            labels: '海关汇率',
            widths: 100
          },
          {
            props: 'payRate',
            labels: '付汇汇率',
            widths: 100
          },
          {
            props: 'payCnyAmount',
            labels: '折算人民币',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'tariffRate',
            labels: '关税率(%)',
            widths: 100
          },
          {
            props: 'copeTariff',
            labels: '进口关税',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'copeVatCost',
            labels: '进口增值税',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'otherTax',
            labels: '进口消费税',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'serviceAmount',
            labels: '进口服务费',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'incidentalAmount',
            labels: '杂费',
            widths: 120,
            type: 'money',
            align: 'right'
          },
          {
            props: 'priceCal',
            labels: '人民币单价',
            widths: 120,
            type: 'money',
            isDecimal: true,
            align: 'right'
          },
          {
            props: 'remark',
            labels: '备注',
            widths: 200
          },
          {
            props: 'invoiceType',
            labels: '发票税率',
            widths: 100
          },
          {
            props: 'usdAmount',
            labels: '折算USD',
            widths: 120,
            type: 'money',
            align: 'right'
          }
        ],
        tableData: [],
  
        // 勾选行
        multiSelected: [],
  
        // 分页数据
        pageTotal: 1,
        pages: {
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
          total: 0
        }
      }
    },
  
    computed: {
  
    },
  
    methods: {
      localSearch() {
        this.pages.currentPage = 1
        this.searchForm()
      },
  
      filterColumns(array) {
        this.columns = array
      },
  
      searchForm(pages) {
        if (pages) {
          this.pages.currentPage = pages.currentPage
          this.pages.pageSize = pages.pageSize
        }
        let params = Object.assign({}, { data: this.formSearch }, { addNumbers: ['3010', '3020'] }, { pageNum: this.pages.currentPage, pageSize: this.pages.pageSize })
        params.data.listBizType = [ '01', '02' ]
        this.$post('/cms/client/customsAccount/entryList', params, this.loading, 'table').then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.tableData = data.result.list
            this.pages.total = data.result.total
          } else {
            this.$message.error(data.message)
          }
        })
      },
      
      selectionChange(array) {
        this.multiSelected = array
      },
  
      exportFile() {
        let params = Object.assign({}, { data: this.formSearch }, { excelField: this.columns.map(e => e.props) })
        params.data.listBizType = [ '01', '02' ]
        params.data.isImportTotal = 1
        this.loading.export = true
        this.$post('/cms/client/customsAccount/expEntry', params).then(({ data }) => {
          if (data && data.code === 'C0000') {
            // 创建隐藏的可下载链接
            var eleLink = document.createElement('a')
            eleLink.download = ''
            eleLink.style.display = 'none'
            // 字符内容转变成blob地址
            eleLink.href = data.message
            // 触发点击
            document.body.appendChild(eleLink)
            eleLink.click()
            // 然后移除
            document.body.removeChild(eleLink)
          } else {
            this.$message.error(data.message)
          }
        }).finally(() => {
            this.loading.export = false
        })
      },
  
      // 刷新
      refreshFn() {
        let params = Object.assign({}, { data: this.formSearch }, { addNumbers: ['3010', '3020'] })
        params.data.listBizType = [ '01', '02' ]
        this.loading.refresh = true
        this.$post('/cms/customsAccount/replenishAndRefresh', params).then(({ data }) => {
          if (data && data.code === 'C0000') {
            this.$message({ message: data.message, type: 'success' })
            this.localSearch()
          } else {
            this.$message.error(data.message)
          }
        }).finally(() => {
            this.loading.refresh = false
        })
      },
      
      cellClassName({ row, column, rowIndex, columnIndex }) {
        if (column.property === 'payRate' && row.payRateIsRed) {
          return 'red-font'
        } else if (column.property === 'remark') {
          return 'line-feed'
        }
        return ''
      },
  
      summaryMethod(param) {
        const { columns, data } = param
        const sums = []
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '合计'
            return
          }
          const values = data.map(item => Number(item[column.property]))
          if (['count', 'amount', 'payCnyAmount', 'copeTariff', 'copeVatCost', 'otherTax', 'serviceAmount', 'incidentalAmount', 'usdAmount'].includes(column.property)) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return this.$calc.add(prev, curr)
              } else {
                return prev
              }
            }, 0)
            sums[index] = column.property === 'count' ? sums[index] : this.$filters.formatMoney(sums[index])
          } else {
            sums[index] = ''
          }
        })
        return sums
      }
    }
  }
  </script>
  
  <style lang="scss">
  .import-statistics-material {
    .statisticsPopover{
        display: flex;
        .el-tooltip__trigger{
            margin-left: 4px;
            padding-top: 3px;
            box-sizing: border-box;
            height: 23px;
        }
    }
    .count_desc {
      position: absolute;
      font-size: 12px;
      width: 210px;
      right: 68px;
      line-height: 24px;
      height: 24px;
  
      .count {
        color: #f56c6c;
        font-size: 16px;
        font-weight: 600;
      }
  
      .separator {
        margin: 0 10px;
      }
    }
  
    .p-table {
      margin-top: 6px;
      .table-hd-question {
        font-size: 15px;
        color: #02a7f0;
      }
      .red-font {
        color: #f00;
      }
      .line-feed > div {
        white-space: pre-line;
      }
    }
    .taber-right {
        float: right;
        margin-top: 20px;
    }
    .amount {
        color: #f56c6c;
    }
    .el-table.is-scrolling-left th.el-table-fixed-column--left {
        background-color:#F2F7FF;
    }
    .table-toolber {
        margin-bottom: 20px;
    }
  }
  </style>
  